import axios from '../plugins/axios'

export default {
    widget({ date_from, date_to }){
        return axios.get('/api/v1/reports/widgets', { params: {
          date_from: date_from,
          date_to: date_to
         }
       })
    },
    pop_up({ date_from, date_to }){
        return axios.get('/api/v1/reports/pop-ups', { params: {
          date_from: date_from,
          date_to: date_to
         }
       })
    },
    area_pop_up({ date_from, date_to }){
        return axios.get('/api/v1/reports/area-pop-ups', { params: {
          date_from: date_from,
          date_to: date_to
         }
       })
    },
    overlay_image({ date_from, date_to }){
        return axios.get('/api/v1/reports/overlay-image', { params: {
          date_from: date_from,
          date_to: date_to
         }
       })
    },
    popup(params){
      return axios.get('/api/v1/reports/popup', { params: params })
    },
    new_overlay_image( params ){
      return axios.get('/api/v1/reports/new-overlay-image', { params: params })
    },
    creative( params ){
        return axios.get('/api/v1/reports/creatives', { params: params })
    },
    scenario_popup(params){
      return axios.get('/api/v1/reports/scenario_popups', { params: params })
    },
    scenario_creative(params){
      return axios.get('/api/v1/reports/scenario_creatives', { params: params })
    },
    cv_tag_names(){
      return axios.get('/api/v1/reports/cv_tag/names')
    },
    save_custom_col({ custom_col_name, selected_tab, custom_cols}){
      return axios.post('/api/v1/reports/save_custom_col', {
        custom_col_name: custom_col_name,
        selected_tab: selected_tab,
        custom_cols: custom_cols
      })
    },
    custom_col_names({ selected_tab}){
      return axios.get('/api/v1/reports/custom_col_names', {
        params: {
          selected_tab: selected_tab
        }
      })
    },
    destroy_col({ custom_col_id }){
      return axios.post('/api/v1/reports/destroy_col', {
        custom_col_id: custom_col_id
      })
    }
}
